/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react"
import { useRouter } from "next/router"
import { Breadcrumb } from "@components/anti/Breadcrumb"
import { Button } from "@components/anti/Button"
import { Card } from "@components/anti/Card"
import { Cover } from "@components/anti/Cover"
import Input from "@components/anti/Forms/components/input"
import Select from "@components/anti/Forms/components/select"
import Link from "@components/anti/Link"
import CardList from "@components/global/CardList"
import { fetchAPI, getAllCityList } from "lib/api"
import { Q_OUTLET_LIST, Q_SEARCH_OUTLET } from "lib/query"
import { linkLocations } from "src/helper/page-url"
import { translations } from "src/helper/translations"
import { imgUrl } from "src/mixins"

import bg from "@public/img/bg/img_bg-home-mobile.jpg"
import bgDesktop from "@public/img/bg/img_bg-home.jpg"
import { metaDesc } from "src/helper/meta-desc"

function LocationsPage({ locale, listCity }) {
  // ============================ STATES ============================ //
  const router = useRouter()
  const [state, setState] = useState({
    loading: false,
    loadingMore: false,
    location: "",
    listCity: [],
    listOutlets: [],
    pagination: {},
    city: { label: translations[`all_city_${locale}`], value: 0 },
  })
  // ============================ STATES ============================ //
  // ============================ FUNCTIONS ============================ //
  const handleChangeState = (value) =>
    setState((prev) => ({ ...prev, ...value }))
  const onFetchOutlets = async (variables) => {
    try {
      const outletsUpdate = await fetchAPI(
        variables.location ? Q_SEARCH_OUTLET : Q_OUTLET_LIST,
        {
          variables,
        }
      )
      handleChangeState({
        listOutlets:
          outletsUpdate[`${variables.location ? "searchOutlets" : "outlets"}`]
            ?.data,
        pagination:
          outletsUpdate[`${variables.location ? "searchOutlets" : "outlets"}`]
            ?.paginatorInfo,
      })
    } catch (error) {
      // need error handle
      // eslint-disable-next-line no-console
      console.error("error ===>", error)
    } finally {
      handleChangeState({ loading: false })
    }
  }
  const onSearch = (query) => {
    const queryFinal = { ...query }
    Object.keys(query).forEach((item) => {
      if (!query[item]) delete queryFinal[item]
    })
    router.push(
      {
        pathname: linkLocations,
        query: { ...queryFinal },
      },
      null,
      { scroll: false }
    )
  }
  const onClickLoadMore = async () => {
    setState((prev) => ({ ...prev, loadingMore: true }))
    try {
      const { city, location } = state
      const variables = {
        city_id: city?.value,
        location,
        first: 12,
        page: state.pagination.currentPage + 1,
        orderBy: [
          {
            column: `title_${locale}`,
            order: "ASC",
          },
        ],
      }
      if (city.value === 0) delete variables.city_id
      if (!location) delete variables.location
      const outletsUpdate = await fetchAPI(
        variables.location ? Q_SEARCH_OUTLET : Q_OUTLET_LIST,
        {
          variables,
        }
      )
      handleChangeState({
        listOutlets: [...state.listOutlets, ...outletsUpdate.outlets.data],
        pagination: outletsUpdate.outlets.paginatorInfo,
      })
      return outletsUpdate
    } catch (error) {
      return { notFound: true }
    } finally {
      setState((prev) => ({ ...prev, loadingMore: false }))
    }
  }
  // ============================ FUNCTIONS ============================ //
  // ============================ REACT OPS ============================ //
  useEffect(() => {
    if (!state.listCity?.length && listCity?.length) {
      handleChangeState({
        listCity: [
          { label: translations[`all_city_${locale}`], value: 0 },
          ...listCity.map((item) => ({ label: item.name, value: item.id })),
        ],
      })
    }
  }, [listCity, state?.listCity?.length, locale])
  useEffect(() => {
    const { city, location } = router.query
    const variables = {
      city_id: +city,
      location,
      first: 12,
      page: 1,
      orderBy: [
        {
          column: `title_${locale}`,
          order: "ASC",
        },
      ],
    }
    const findCity = listCity.find((item) => item.id === +city) || {
      name: translations[`all_city_${locale}`],
      id: 0,
    }
    setState((prev) => ({
      ...prev,
      city: { label: findCity.name, value: findCity.id },
      location,
    }))
    if (!variables.city_id) delete variables.city_id
    if (!variables.location) delete variables.location
    onFetchOutlets(variables)
  }, [router])
  // ============================ REACT OPS ============================ //

  return (
    <>
      <section className="sc-locations-landing-cover">
        <Cover
          title={translations[`location_landing_title_${locale}`]}
          titleClassName="pt-main"
          contentMaxWidth="w-100"
          imgHeight="h-550px h-md-600px"
          img={bg.src}
          imgMd={bgDesktop.src}
          breadcrumb={
            <Breadcrumb
              path={`/${translations[`location_${locale}`]}`}
              theme="dark"
            />
          }
        >
          <div className="location__search-wrapper">
            <div className="row mx-0">
              <div className="col-md-3">
                <Select
                  label={translations[`city_label_${locale}`]}
                  floatingLabel
                  variant="underline"
                  value={state.city}
                  options={state.listCity}
                  onChange={(_, value) => {
                    onSearch({ city: value.value, location: state.location })
                  }}
                  isSearchable
                />
              </div>
              <div className="col-md-8">
                <Input
                  variant="underline"
                  value={state.location}
                  placeholder={
                    translations[`search_location_placeholder_${locale}`]
                  }
                  onChange={(e) => {
                    handleChangeState({ location: e.target.value })
                    if (!e.target.value) {
                      onSearch({
                        city: state?.city?.value,
                        location: "",
                      })
                    }
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      onSearch({
                        city: state?.city?.value,
                        location: e.target.value,
                      })
                    }
                  }}
                />
              </div>
              <div className="col-md-1">
                <Button
                  variant="outline-white"
                  iconLeft="air ai-search"
                  onClick={() =>
                    onSearch({
                      city: state?.city?.value,
                      location: state.location,
                    })
                  }
                  className={state.loading ? "loading" : ""}
                >
                  {translations[`search_${locale}`]}
                </Button>
              </div>
            </div>
          </div>
        </Cover>
      </section>
      <section className="sc-locations-landing-list">
        <div className="container py-main">
          <CardList
            grid="col-6 col-md-4"
            data={state.listOutlets}
            className="list-location"
            keyPrefix="location-item"
            // showTotal={state?.pagination?.total}
            onClickLoadMore={onClickLoadMore}
            hasMore={state?.pagination?.hasMorePages}
            notFoundTitle={translations[`not_found_cinema_title_${locale}`]}
            notFoundText={translations[`not_found_cinema_text_${locale}`]}
            loading={state.loadingMore}
            render={(item, i) => {
              const iconGroup = []
              if (item.is_3d)
                iconGroup.push({ icon: "/img/icon/img_icon-3d.svg" })
              if (item.is_thx)
                iconGroup.push({ icon: "/img/icon/img_icon-thx.svg" })
              if (item.is_dolby_atmos)
                iconGroup.push({ icon: "/img/icon/img_icon-atmos.svg" })
              return (
                <Card
                  link={`${linkLocations}/${item.slug}`}
                  iconGroup={iconGroup}
                  imgRatio="r-4-3"
                  className="list-location__item"
                  img={imgUrl(item?.thumb_image)}
                  title={item[`title_${locale}`]}
                  text={
                    <>
                      <p>{item?.excerpt_id}</p>
                      <p>{item?.address}</p>
                      <p>{item?.city?.name}</p>
                    </>
                  }
                >
                  <div className="with-arrow text-capitalize">
                    {translations[`view_detail_${locale}`]}
                    <i className="cxi-arrow-right" />
                  </div>
                </Card>
              )
            }}
          />
        </div>
      </section>
    </>
  )
}
export default LocationsPage

export async function getStaticProps(ctx) {
  const { locale } = ctx
  const listCity = await getAllCityList({})
  return {
    props: {
      seo: {
        title: "Locations",
        description: metaDesc[`location_${locale}`],
      },
      page: "locations",
      // data: data?.outlets,
      listCity,
      locale,
    },
    revalidate: 60,
  }
}
